import { useSyncExternalStore } from "react"

const MOBILE_BREAKPOINT = 768
const TABLET_BREAKPOINT = 992

function useBelowBreakpoint(breakpoint: number) {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
      mql.addEventListener("change", onChange)
      return () => mql.removeEventListener("change", onChange)
    },
    () => window.innerWidth < breakpoint,
    () => false
  )
}

export function useIsMobile() {
  return useBelowBreakpoint(MOBILE_BREAKPOINT)
}

export function useIsTablet() {
  return useBelowBreakpoint(TABLET_BREAKPOINT)
}
